import { render, staticRenderFns } from "./AnnotationAuditLogPanel.vue?vue&type=template&id=7878fce2&scoped=true"
import script from "./AnnotationAuditLogPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationAuditLogPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnotationAuditLogPanel.vue?vue&type=style&index=0&id=7878fce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878fce2",
  null
  
)

export default component.exports